export default {
    title: "Potvrzení o doručení",
    header: "@:views.survey.delivery.title",
    result: {
        header: "Děkuju",
        message: "Děkuji za vaši odpověď."
    },
    status: {
        yes: "Prosím, ověřte níže uvedené zaškrtnuté produkty pro potvrzení doručení a zrušte zaškrtnutí těch, které jste neobdrželi. Poté klikněte na Odeslat pro potvrzení.",
        no: "Prosím, ověřte, že jste neobdrželi žádný z níže uvedených produktů. Pokud jste některý z těchto produktů obdrželi, zaškrtněte políčko vedle obdrženého produktu (produktů) a potvrďte kliknutím na tlačítko Odeslat."
    },
    model: {
        checked: {
            label: "Přijato"
        }
    },
    button: {
        submit: {
            cta: "Předložit",
            processing: "Odesílání"
        }
    }
}